import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, LinkText, Button } from '@components/common';
import { AuthSelectors } from '@redux/AuthRedux';
import { TableHeading } from '@components/Typography';

function LinkedInfo() {
  return (
    <React.Fragment>
      <TableHeading mb={4}>Linked Accounts</TableHeading>
      <Box display={['none', 'flex']} flexDirection="column">
        <LinkText mb={4}>Add Facebook</LinkText>
        <LinkText mb={4}>Add Google</LinkText>
      </Box>
      <Box display={['flex', 'none']} flexDirection="column">
        <Button variant="secondary" mb={4}>
          Add Facebook
        </Button>
        <Button variant="secondary" mb={4}>
          Add Google
        </Button>
      </Box>
    </React.Fragment>
  );
}

LinkedInfo.propTypes = {
  user: PropTypes.object
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

export default connect(mapStatesToProps)(LinkedInfo);
